import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { EvTaskTypes, RegistrationForm } from "../_loadingHelpers/EvTask";
import Tooltip from '../../moreCore/UI/Floating/Tooltip';
import EvTaskView from './EvTaskView';


class EvTaskMyTasksAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...


    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private tableFormatter(cell: StaticTable.StaticTableCell<EvTaskTypes.EvTaskListData>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        switch (colName) {
            case "dateStart":
                var dateStart = new Date(entity.date_forerun);
                var formattedDate = dateStart.toLocaleString('de-DE', {
                    hour: '2-digit',
                    minute: '2-digit'
                });

                node.innerHTML = formattedDate;
                return true;
                break;

            case "dateEnd":
                var dateEnd = new Date(entity.date_trailer);
                var formattedDate = dateEnd.toLocaleString('de-DE', {
                    hour: '2-digit',
                    minute: '2-digit'
                });

                node.innerHTML = formattedDate;
                return true;
                break;

            case "durationTotal":
                var durationTotal = entity.duration_total / 60;

                var FormattedDuration = Intl.NumberFormat("de-DE").format(durationTotal);

                if (!FormattedDuration) {
                    node.innerHTML = "-";
                }
                else {
                    node.innerHTML = FormattedDuration + " Stunden";
                }

                return true;
                break; 

            case "myRegistrationStatus":

                let employeeID = window.sessionInfo?.sessionData?.CurrentEmployeeId;
                let status = entity.tmp_status_current_employee;
                let iconClass = "fas fa-question";

                switch (status) {
                    case "available":
                        iconClass = "far fa-circle w3-text-blue";
                        break;

                    case "unavailable":
                        iconClass = "fas fa-ban w3-text-red";
                        break;

                    case "applied":
                        iconClass = "far fa-user-circle w3-text-orange";
                        break;

                    case "assignedToMe":
                        iconClass = "fas fa-user-circle w3-text-green";
                        break;

                    case "assignedToOther":
                        iconClass = "far fa-user secondaryTXT";
                        break;
                }

                let icon = this.createFontawesomeIcon(iconClass);

                let tooltip = new Tooltip();
                tooltip.setup({
                    targetnode: node,
                    content: entity.tmp_statustext_current_employee,
                    delayMS: 100,
                });

                node.innerHTML = icon.outerHTML;
                return true;
                break;
            //default:
            //    node.innerHTML = value;
            //    return true;
        }

        return false;
    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
    //    this.createContextButton({
    //        label: "??",
    //        callback: lang.hitch(this, this._onClick_Context),
    //        placement: "top",
    //        /*iconClass: "fas fa-calendar-times",*/
    //        permanent: false
    //    });
    }


    private _onClick_Row(row: StaticTable.StaticTableRow<EvTaskTypes.EvTaskListData>) {


        let entity = row.rowGroup.entity;

    //    let entityview = new GenericEntityView();
    //    entityview.setup({
    //        entityId: row.rowGroup.entity.ID,
    //        entityClass: row.rowGroup.entity.Classname,
    //        label: row.rowGroup.entity.gDisp_1,
    //        labelProperty: "gDisp_1",
    //        contextName: "MyTaskAgenda"
        //    });

        let entityview = new EvTaskView();
        entityview.setup(entity.ID, entity.gDisp_1, "MyTaskAgenda", this.getTabContainerName());

    }
    
    private startAgenda(hasPrivilege: boolean) {
        if (!hasPrivilege) {
            this.destroy();
            return;
        }
       
        this.setupAgendaViewWithCallfunction(
            "Webtool_API_EvTaskMyTasks__GetAgendaFilterOptionsJSON",
            "Webtool_API_EvTaskMyTasks__GetAgendaResultListJSON",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this.tableFormatter),
            null,
            null,        // Standard-Formatter
            new Date()
        )
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.hasUserRole("EvTask_MyTasks", lang.hitch(this, this.startAgenda));

    }
    
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskMyTasksAgenda);